module.exports = __webpack_public_path__ + "siteweb/img/ad-info1.efd93dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-info1.png
// module id = 9Jq9
// module chunks = 1